const moderatePitchThreshold = -0.2; // -11.6479 degrees
const severePitchThreshold = -0.8; // -45.8366 degrees
const thresholdCountPercentage = 0.7;
const sensorCompensation = 0.22;

// Enum for ArmWeaknessValue
const ArmWeaknessValue = {
  MODERATE: 'MODERATE',
  SEVERE: 'SEVERE',
  NORMAL: 'NORMAL',
  UNABLE_TO_PERFORM: 'UNABLE_TO_PERFORM',

  weaknessDetected(value) {
    return value === this.MODERATE || value === this.SEVERE;
  },
};

// Function to assess arm weakness
export function assessArmWeakness(pitchValues) {
  if (!pitchValues) return ArmWeaknessValue.UNABLE_TO_PERFORM;

  let belowModerateThresholdCount = 0;
  let belowSevereThresholdCount = 0;

  for (let pitch of pitchValues) {
    let adjustedPitch = pitch - sensorCompensation;

    if (adjustedPitch < moderatePitchThreshold) {
      belowModerateThresholdCount++;
      if (adjustedPitch < severePitchThreshold) {
        belowSevereThresholdCount++;
      }
    }
  }

  if (belowSevereThresholdCount / pitchValues.length > thresholdCountPercentage) {
    return ArmWeaknessValue.SEVERE;
  } else if (belowModerateThresholdCount / pitchValues.length > thresholdCountPercentage) {
    return ArmWeaknessValue.MODERATE;
  } else {
    return ArmWeaknessValue.NORMAL;
  }
}
